import {
  CREATE, CREATE_SUCCESS, CREATE_ERROR, SHOW_CREATE_TAG_DIALOG,
  SEARCH_TAGS_BY_LABEL ,SEARCH_TAGS_BY_LABEL_SUCCESS, SEARCH_TAGS_BY_LABEL_ERROR,
  EDIT, EDIT_SUCCESS, EDIT_ERROR,
  DELETE, DELETE_SUCCESS,
  DETACH, DETACH_SUCCESS, DETACH_ERROR,
  SHOW_ATTACH_TAG_DIALOG,
  ATTACH_TAG, ATTACH_TAG_SUCCESS, ATTACH_TAG_ERROR, CREATE_NEW_TAG_FROM_ATTACH_TAG_SUCCESS,
  ATTACH_TAG_SEARCH_CLEARED,
  HANDLE_DEVICE_TAGS_LOAD
 } from './actions';

const initialState = {
  data: [],
  isLoading: false,
  error: null,
  currentPage: 0,
  searchTagPageNumber: 1,
  searchTagsError: null,
  createTag:{
    pending: false,
    error: null,
    showDialog: false,
    isCreateFromAttach: false,
  },
  attachTag:{
    pending: false,
    error: null,
    showDialog: false,
    newTagCreatedFromAttach: false,
    newTagId: null
  },
  detachedTagsList: [],
  newlyAttachedTagsList: []
};

import { collection, composeReducers } from "common/store/reducer";

import { NAMESPACE } from "./actions";

const initial = {
  ...collection.defaultSort("id"),
};

const create = (state) => ({
  ...state,
  createTag: {
    ...state.createTag,
    pending: true,
  },
});

const createSuccess = (state) => ({
  ...state,
  createTag: {
    ...state.createTag,
    pending: false,
  },
});

const onError = (state, { error }) => ({
  ...state,
  createTag:{
    ...state.createTag,
    error,
    pending: false,
  }
});

const showCreateTagDialog = (state, {flag}) => ({
  ...state,
  createTag:{
    ...state.createTag,
    error: null,
    showDialog: flag,
  }
});

const searchTagsByLabel = (state, action) => {
  return ({
    ...state,
  });
}

const searchTagsByLabelSuccess = (state, action) => {
  return ({
    ...state,
    data: action.data,
    total: action.total,
    searchTagPageNumber: action.pageNumber
  });
}

const searchTagsByLabelError = (state, action) => {
  return ({
    ...state,
  });
}
const edit = state => ({
  ...state,
  createTag:{
    ...state.createTag,
    pending: true,
  }

});

const editSuccess = (state, {id, tag}) => ({
  ...state,
  data: state.data.map(obj=>{
    if(obj.tagId === id){
      return {...obj, ...tag};
    }
    return obj;
  }),
  createTag:{
    ...state.createTag,
    pending: false,
  },
  newlyAttachedTagsList: state.newlyAttachedTagsList.map((obj)=>{
      if(parseInt(obj.tagId) === id){
        return {...obj, ...tag};
      }
      return obj;
    })
});

const editError = (state, { error }) => ({
  ...state,
  createTag:{
    ...state.createTag,
    error,
    pending: false,
  }
});

export const deleteTag = (state, {id}) => ({
  ...state,
});

export const deleteSuccess = (state, {id})  => {
  return{
  ...state,
  newlyAttachedTagsList: state.newlyAttachedTagsList.filter((obj)=>parseInt(obj.tagId) !== id)
}};

const detach = (state) => ({
  ...state
});

const detachSuccess = (state, {detachedInfo}) => {
  return({
  ...state,
  detachedTagsList: [...state.detachedTagsList, detachedInfo.tags[0]],
});}

const detachError = (state, { error }) => ({
  ...state
});

const showAttachTagDialog = (state, {flag, fromDeviceFilter}) => ({
  ...state,
  data: [],
  total: undefined,
  searchTagPageNumber: 1,
  createTag:{
    ...state.createTag,
    isCreateFromAttach: false,
  },
  attachTag:{
    ...state.attachTag,
    showDialog: flag,
    newTagCreatedFromAttach: false,
    newTagId: null,
    fromDeviceFilter: fromDeviceFilter
  }
});

const attachTag = (state) => ({
  ...state,
  data: [],
  total: undefined,
  attachTag:{
    ...state.attachTag,
    error: null,
    pending: true
  }
});

const attachTagSuccess = (state, action) => { return({
  ...state,
  data: [],
  total: undefined,
  createTag:{
    ...state.createTag,
    isCreateFromAttach: false,
  },
  attachTag:{
    ...state.attachTag,
    error: null,
    pending: false,
    newTagCreatedFromAttach: false,
    newTagId: null
  },
  detachedTagsList: (action.payload.result[0] !== undefined && action.payload.result[0].tagId) ?
                    (state.detachedTagsList.includes(action.payload.result[0].tagId)?
                      (filterDetachedTagsList(state, action.payload.result[0].tagId)) :
                      ([...state.detachedTagsList])) :
                    [...state.detachedTagsList],
  newlyAttachedTagsList: (action.payload.result[0] !== undefined && action.payload.result[0].tagId && action.tagDets) ?
                          [action.tagDets, ...state.newlyAttachedTagsList] :
                          [...state.newlyAttachedTagsList]
})};

const filterDetachedTagsList = (state, tagId) => {
  return state.detachedTagsList.filter((id)=>{return id !== tagId})
}

const removeDuplicates = (tags) => {
  const ids = tags.map((obj)=>obj.tagId);
  return tags.filter((tag, index)=>ids.indexOf(tag.tagId) === index);
}

const attachTagError = (state, {error}) => ({
  ...state,
  data: [],
  total: undefined,
  attachTag:{
    ...state.attachTag,
    error,
    pending: false
  }
});

const createNewTagFromAttachSuccess = (state, {newTagId}) => ({
  ...state,
  attachTag:{
    ...state.attachTag,
    newTagCreatedFromAttach: true,
    newTagId
  }
});

const attachTagSearchCleared = (state) => ({
  ...state,
  data: [],
  total: undefined,
  attachTag:{
    ...state.attachTag,
    newTagCreatedFromAttach: false,
    newTagId: null
  },
})

const handleDeviceTagsLoad = (state) => ({
  ...state,
  detachedTagsList: [],
  newlyAttachedTagsList: []
})

const collectionReducer = (state = initialState, action) => {
  const reducer = {
    [CREATE]: create,
    [CREATE_SUCCESS]: createSuccess,
    [CREATE_ERROR]: onError,
    [SHOW_CREATE_TAG_DIALOG]: showCreateTagDialog,
    [SEARCH_TAGS_BY_LABEL]: searchTagsByLabel,
    [SEARCH_TAGS_BY_LABEL_SUCCESS]: searchTagsByLabelSuccess,
    [SEARCH_TAGS_BY_LABEL_ERROR]: searchTagsByLabelError,
    [EDIT]: edit,
    [EDIT_SUCCESS]: editSuccess,
    [EDIT_ERROR]: editError,
    [DELETE]: deleteTag,
    [DELETE_SUCCESS]: deleteSuccess,
    [DETACH]: detach,
    [DETACH_SUCCESS]: detachSuccess,
    [DETACH_ERROR]: detachError,
    [SHOW_ATTACH_TAG_DIALOG]: showAttachTagDialog,
    [ATTACH_TAG]: attachTag,
    [ATTACH_TAG_SUCCESS]: attachTagSuccess,
    [ATTACH_TAG_ERROR]: attachTagError,
    [CREATE_NEW_TAG_FROM_ATTACH_TAG_SUCCESS]: createNewTagFromAttachSuccess,
    [ATTACH_TAG_SEARCH_CLEARED]: attachTagSearchCleared,
    [HANDLE_DEVICE_TAGS_LOAD]: handleDeviceTagsLoad,
  }[action.type];

  return reducer ? reducer(state, action) : state;
};

export default composeReducers(
  collection.factory(NAMESPACE),
  collectionReducer,
  (state = initialState) => state
);
